import SVG from './image.svg';
import { face, side } from '~/notations';

export default {
  SVG,
  algorithm: [
    face.r.one,
    face.u.pri,
    side.r.pri,
    face.u.pri,
    face.m.pri,
    face.u.one,
    side.r.one,
    face.u.one,
    side.r.pri,
  ],
  name: '4T & 2B',
};
